import script from "./InfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoCard.vue?vue&type=script&setup=true&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=6d28493c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d28493c"]])

export default __exports__